const FixTagRule = ({ item }) => {
  return {
    item: {
      ...item,
      tags: typeof item.tags === 'string' ? generateTagsArray(item.tags) : item.tags
    }
  }
}

const generateTagsArray = (coreMediaTagsString) => {
  const tagsObject = coreMediaTagsString.split(',').reduce((acc, tag) => {
    const tagSplit = tag.split('/')
    const parent = tagSplit[0]
    const child = tagSplit[1]

    if (acc[parent]) {
      acc[parent].children.push({ text: child })
    } else {
      acc[parent] = {
        text: parent,
        children: [{ text: child }]
      }
    }
    return acc
  }, {})

  return Object.values(tagsObject)
}

export default FixTagRule
